import { Box, Typography } from '@mui/material';

type PaymentInfoProps = {
  newPrice: number;
  currency?: 'CZK' | 'EUR';
};

const PaymentInfo = ({ newPrice, currency = 'CZK' }: PaymentInfoProps) => (
  <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1 }}>
    <Typography variant="body2" color="text.secondary">
      ℹ️ Platíte plnou cenu {currency === 'EUR' ? `${newPrice} €` : `${newPrice} Kč`}. Staré
      předplatné bude ukončeno a nové předplatné bude automaticky prodlouženo o bonus dny za
      zbývající čas.
    </Typography>
  </Box>
);

export default PaymentInfo;
